import { Country } from '@abiglobalhealth/go-types'
import { useContext } from 'react'

import { UserContext, UserContextProps } from '@/contexts/user'
import { handleUserLanguage } from '@/locale/utils'

interface UseUserProps {
  user: UserContextProps['user']
  updateUser: (user: UserContextProps['user']) => void
}

export const useUser = (): UseUserProps => {
  const { user, setUser } = useContext(UserContext)

  const updateUser = async (updatedUser: UserContextProps['user']) => {
    const language = await handleUserLanguage(updatedUser)

    const country = new URLSearchParams(window.location.search).get('country') || undefined
    const countryObj = {
      code: country
    } as Country

    return setUser({
      ...updatedUser,
      data: {
        ...updatedUser?.data,
        language,
        country: updatedUser?.data?.country || (country ? countryObj : undefined)
      }
    })
  }

  return {
    user,
    updateUser
  }
}
